import OptionVM from "@/interfaces/option-vm";

export default class DistributorsWithoutSettingsVM {
    distributors: OptionVM[] = [];
    registrationRevenueMinimum = 0;
}